import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router);
let router = new Router({
  mode: 'history',
  base:"/",
  routes
});

router.beforeEach((from, to, next) => {
  // window.document.title = to.meta.title
  next();


});
router.afterEach((from, to) => {

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js